<template>
  <div>
    <general-service
      :company-id="companyId"
      :service="service"
      :show-multiparking="showMultiparking"
      :show-multi-slot="showMultiSlot"
      :show-plate-restriction="showPlateRestriction"
      @addItem="activeAddItem = true"
    />

    <vs-table search :data="service.itemList" max-items="10" pagination>
      <template slot="thead">
        <vs-th># Tarjeta</vs-th>
        <vs-th>Matrícula</vs-th>
        <vs-th>Fecha inicio</vs-th>
        <vs-th>Fecha final</vs-th>
        <vs-th>Valor</vs-th>
        <vs-th>Propietario</vs-th>
        <vs-th>Opciones</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="item.code" v-for="item in data" :state="rowColor(item)">
          <vs-td :data="item.identification">{{ item.identification }}</vs-td>
          <vs-td :data="item.info.plate">{{ item.info.plate }}</vs-td>
          <vs-td :data="item.startDate">{{ formatDate(item.startDate) }}</vs-td>
          <vs-td :data="item.finalDate">{{ formatDate(item.finalDate) }}</vs-td>
          <vs-td :data="item.total">{{ item.total }}</vs-td>
          <vs-td :data="item.entityOwner.name">{{
            item.entityOwner.name
          }}</vs-td>
          <vs-td>
            <button
              class="btn remove"
              v-on:click="deleteItem(item)"
              title="Eliminar"
            >
              <span class="material-icons"> delete_forever </span>
            </button>
            <button
              class="btn primary edit"
              v-on:click="editItem(item)"
              title="Editar"
            >
              <span class="material-icons"> edit </span>
            </button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="columns">
      <div class="column is-3">
        <b-button @click="deleteService" type="is-danger"
          >Eliminar servicio</b-button
        >
      </div>
    </div>
    <div v-if="activeAddItem">
      <parking-item
        ref="parkingItem"
        :is-show="activeAddItem"
        :record="selectedItem"
        :service="service"
        @closePrompt="closePrompt"
        @saveItem="addItem"
        @editItem="updateItem"
      />
    </div>
  </div>
</template>

<script>
import GeneralService from '@/views/income-special/subscriber/services/GeneralService.vue'
import ParkingItem from '@/views/income-special/subscriber/prompt/ParkingItem'
import { formatPrice } from '@/global/utils'
import DateUtils from '@/global/DateUtils'
import toast from '@/global/ToastConfig'

export default {
  name: 'ParkingService',
  props: {
    companyId: Number,
    service: Object,
    showMultiparking: {
      type: Boolean,
      default: false,
    },
    showPlateRestriction: {
      type: Boolean,
      default: false,
    },
    showMultiSlot: {
      type: Boolean,
      default: false,
    },
  },
  components: { GeneralService, ParkingItem },
  data() {
    return {
      selectedItem: null,
      perPage: 10,
      total: 0,
      page: 1,
      defaultSortOrder: 'asc',
      sortOrder: 'asc',
      sortField: 'identification',
      loading: false,
      activeAddItem: false,
    }
  },
  mounted() {
    this.total = this.service.itemList.length
  },
  methods: {
    addItem(item) {
      item.position = this.service.itemList.length
      this.service.itemList.push(item)
      this.updateTotal()
    },
    editItem(record) {
      record.startDate = this.parserDate(record.startDate)
      record.deletionDate = this.parserDate(record.deletionDate)
      record.finalDate = this.parserDate(record.finalDate)
      if (record.info instanceof String) record.info = JSON.parse(record.info)
      this.selectedItem = record
      this.activeAddItem = true
      this.updateTotal()
    },
    deleteItem(record) {
      toast
        .ask(this, `¿Está seguro de eliminar el item ${record.identification}?`)
        .then((result) => {
          if (!result) return
          record.status = 'DELETED'
          this.updateTotal()
        })
    },
    updateItem(record) {
      this.service.itemList[record.position] = record
      this.selectedItem = null
      this.updateTotal()
    },
    updateTotal() {
      let total = 0
      this.service.itemList.forEach((item) => {
        if (item.status !== 'DELETED') {
          total += parseInt(item.total)
        }
      })
      this.service.total = total
      this.$emit('updateTotal', this.service.total)
    },
    currency(num) {
      return formatPrice(num)
    },
    formatDate(a) {
      if (!a) {
        return '-'
      }
      return DateUtils.toDateShortString({ date: a })
    },
    parserDate(a) {
      if (a) {
        return DateUtils.parse({ date: a }).toDate()
      }
    },
    closePrompt() {
      this.activeAddItem = false
      this.selectedItem = null
    },
    deleteService() {
      toast
        .ask(this, '¿Está seguro de eliminar el servicio?')
        .then((result) => {
          if (result) {
            this.$emit('deleteService', this.service)
          }
        })
    },
    rowColor(row) {
      const status = row.status
      switch (status) {
        case 'ACTIVE':
          return 'success'
        case 'DELETED':
          return 'danger'
        case 'PENDING':
          return 'primary'
        case 'BLOCKED':
          return 'warning'
      }
    },
  },
}
</script>

<style scoped></style>
